import SplitType, { TargetElement } from 'split-type';
import { gsap } from 'gsap'
// import { ScrollTrigger } from "gsap/ScrollTrigger";
import debounce from 'debounce';

type QueryNode = Document | ShadowRoot | HTMLElement;

const revert_on_check =
	(el: Element, text: SplitType) =>
		el.getAttribute('data-splittype-revert') != undefined ? text.revert() : null;

// TODO: check if an animation that splits text has any kind of underline
// and replace with a fake underline (using ::after psudo element)

export const init_text_animation = (node: QueryNode) => {
	const REDUCED_MOTION = window.matchMedia(`(prefers-reduced-motion)`).matches;

	// Simple Fade in and move up animation with reverses when scrolling back
	if (!REDUCED_MOTION) {
		node.querySelectorAll('[data-gsap-anim*="fade-up"]').forEach(el => {
			gsap.from(el, {
				opacity: 0,
				y: '10rem',
				duration: 0.5,
				scrollTrigger: {
					trigger: el,
					start: 'top bottom 1.25rem',
					toggleActions: 'play none none reverse',
				}
			});
		});
	} else {}
	// Split into characters and drop each with a bounce
	if (!REDUCED_MOTION) {
		node.querySelectorAll('[data-gsap-anim*="char-by-char_rnd-bounce"]').forEach(el => {
			gsap.set(el, {fontKerning: 'none'});
			let text = new SplitType(el as TargetElement, {types: 'chars'});
			gsap.from(text.chars, {
				opacity: 0,
				stagger: 0.05,
				duration: 0.6,
				y: '-2rem',
				repeatRefresh: true,
				delay: 'random(0.1, 1)',
				ease: 'bounce.out',
				scrollTrigger: {
					trigger: el,
					start: 'top bottom 1.25rem',
				},
				onComplete: () => revert_on_check(el, text),
			});
		});
	} else {}
	// Split into lines and clip in each element
	if (!REDUCED_MOTION) {
		node.querySelectorAll('[data-gsap-anim*="clip-in-lines"]').forEach(el => {
			let text = new SplitType(el as TargetElement, {types: 'lines'});
			// Hide the overflow of the "container" for clipping effect with Tailwind class
			text.lines?.forEach(x => x.classList.add('overflow-hidden'));
			if (text.lines?.length) {
				let wrapped_lines: Array<HTMLElement> = [];
				// Wrap the contents of each line in a <div>
				text.lines.forEach(x => {
					let inner = x.innerHTML;
					x.innerHTML = '';
					let new_inner = document.createElement('div');
					new_inner.innerHTML = inner;
					x.appendChild(new_inner);
					wrapped_lines.push(new_inner);
				});
				// Animate the inner content
				gsap.from(wrapped_lines, {
					y: '5rem',
					delay: 0.5,
					stagger: 0.05,
					duration: 1,
					ease: 'power3.out',
					scrollTrigger: {
						trigger: el,
						start: 'top bottom 1.25rem',
						toggleActions: 'play none none reverse',
					},
				});
			}
		});
	} else {}

	if (!REDUCED_MOTION) {
		node.querySelectorAll('[data-gsap-anim*="clip-in-paragraphs"]').forEach(el => {
			let ps = el.querySelectorAll('p');
			if (ps.length) {
				ps.forEach(p => {
					let wrap = document.createElement('div');
					wrap.classList.add('overflow-hidden');
					el.before(wrap, p);
					p.remove();
					wrap.appendChild(p);
				});
				ps.forEach((p, i) => {
					console.log('p height', p.offsetHeight + 16 + 'px');
					gsap.from(p, {
						// height of the element plus "1rem" to ensure if it overflowed
						y: p.offsetHeight + 16 + 'px',
						delay: 0.25 * i,
						duration: 1,
						ease: 'power3.out',
						scrollTrigger: {
							trigger: p,
							start: 'top bottom 1.25rem',
							toggleActions: 'play none none reverse',
						},
					});
				});
			}
		});
	} else {}

	// Timeline animations
	if (!REDUCED_MOTION) {
		const card_dur = 0.5;
		const h_bar_dur = 0.25;
		const h_bar_delay = card_dur;
		const date_dur = 0.25;
		const date_delay = card_dur + h_bar_dur;
		const v_bar_dur = 0.25;
		const v_bar_delay = card_dur + h_bar_dur + date_dur;

		let timelines = node.querySelectorAll('.timeline-grid');
		timelines.forEach(tl => {
			tl.querySelectorAll('.event-card').forEach(ec => {
				let odd = ec.classList.contains('odd-card');
				gsap.from(ec, {
					duration: card_dur,
					x: (odd ? '-' : '') + "50rem",
					opacity: 0,
					scrollTrigger: {
						trigger: ec,
						start: 'top center',
					}
				})
				let eb = <gsap.DOMTarget>document.evaluate(
					'following-sibling::div[contains(@class, "timeline-bar")]',
					ec,
					null,
					XPathResult.FIRST_ORDERED_NODE_TYPE
				)?.singleNodeValue;
				if (eb) {
					gsap.from(eb, {
						duration: h_bar_dur,
						delay: h_bar_delay,
						width: 0,
						scrollTrigger: {
							trigger: ec,
							start: 'top center',
						}
					})
				}
				let date = <gsap.DOMTarget>document.evaluate(
					'following-sibling::div[contains(@class, "event-date")]',
					ec,
					null,
					XPathResult.FIRST_ORDERED_NODE_TYPE
				)?.singleNodeValue;
				if (date) {
					gsap.from(date, {
						duration: date_dur,
						delay: date_delay,
						scale: 0,
						scrollTrigger: {
							trigger: ec,
							start: 'top center',
						}
					})
				}
				let v_bar = <gsap.DOMTarget>document.evaluate(
					'following-sibling::div[contains(@class, "v-bar")]',
					ec,
					null,
					XPathResult.FIRST_ORDERED_NODE_TYPE
				)?.singleNodeValue;
				if (v_bar) {
					gsap.from(v_bar, {
						duration: v_bar_dur,
						delay: v_bar_delay,
						height: 0,
						scrollTrigger: {
							trigger: ec,
							start: 'top center',
						}
					})
				}
			});
		});
	} else {
	}
}